import styled, {css} from "styled-components"

import Flex, {FlexProps} from "@irati/ui/src/Flex"
import {Para} from "@irati/ui/src/Labels"
import {IconTooltip} from "@irati/ui/src/Tooltip"

// Default Renderer
interface OptionRowProps extends FlexProps {
  defaultRenderer?: boolean,
  disabled?: boolean,
  whiteSpace?: "wrap" | "nowrap" | "pre"
}
export const RadioOptionRow = styled(Flex)<OptionRowProps>`
  ${({whiteSpace}) => whiteSpace && `white-space: ${whiteSpace || "nowrap"};`}
  ${({defaultRenderer}) => defaultRenderer && "margin: 0 20px 15px 0;"}
  justify-content: flex-start;
  cursor: pointer;
  transform: translate3d(1px, 1px, 0);
  ${({disabled}) => disabled && `
    cursor: not-allowed;
    opacity: 0.7;
  `}
`

export const RadioOptionText = styled(Para)`
  white-space: normal;
  word-break: normal;
`
export const RadioIconContainer = styled.div`
  width: 40px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export interface RadioIconProps {
  checked: boolean
}
export const RadioIcon = styled.div<RadioIconProps>`
  align-self: center;
  width: 20px;
  height: 20px;
  min-width: 20px;
  position: relative;
  display: flex;
  background-color: ${({theme}) => theme.colors.greys.white};
  box-shadow: 0 0 0 1px ${({theme}) => theme.colors.greys.mediumDark};
  border-radius: 50%;
  margin-right: 22px;

  ${({checked}) =>
    checked &&
    css`
      &:after {
        content: "";
        position: absolute;
        top: calc(50% - 5px);
        left: calc(50% - 5px);
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: ${({theme}) => theme.colors.perkbox.blue};
      }
    `}
`

// Tooltip Renderer
export const MarginIconTooltip = styled(IconTooltip)`
  margin-left: 15px;
`
